export interface ILookup<T> {
  id: T;
  description: string;
}